module.exports = __webpack_public_path__ + "static/media/IconModalAcessoPerfil.9f014c52.svg";